"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThankYouModule = void 0;
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@services/settings.service");
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var cash_dom_1 = __importDefault(require("cash-dom"));
var magicline_api_1 = require("../../../api/magicline-api");
var mappings_const_1 = require("../const/mappings.const");
var data_processing_service_1 = require("../services/data-processing.service");
var ThankYouModule = /** @class */ (function () {
    function ThankYouModule() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.magiclineApi = object_service_1.ObjectService.getInstance(magicline_api_1.MagiclineApi);
        this.dataProcessing = object_service_1.ObjectService.getInstance(data_processing_service_1.DataProcessing);
    }
    ThankYouModule.prototype.loadModule = function (customer, moduleDiv) {
        return __awaiter(this, void 0, void 0, function () {
            var termId, studioId, offerings, error_1, bookedOffering, refObjectId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        termId = localStorage.getItem('Memberships');
                        studioId = localStorage.getItem('Location');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.magiclineApi.getOfferings(studioId)];
                    case 2:
                        offerings = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        (0, generator_const_1._ShowErrorMessage)(mappings_const_1._Messages.GetError);
                        console.error(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        if (offerings.length) {
                            bookedOffering = offerings.find(function (offering) {
                                return offering.terms.some(function (term) { return term.id.toString() === termId; });
                            });
                            refObjectId = '#' + this.config.get.fitpos.refObjectMyContracts;
                            if (bookedOffering) {
                                bookedOffering['price'] = bookedOffering.terms
                                    .find(function (term) { return term.id.toString() === termId; })
                                    .price.toString(); //Needed for output
                                // TODO if undefined
                                // const clone = this.helper.createClonesForRefObjectId([], refObjectId);
                                // if (clone) {
                                //   this.dataProcessing.fillDataGet(clone[0], bookedOffering);
                                // }
                                // $(refObjectId).parent().append(clone);
                            }
                            else {
                                (0, cash_dom_1.default)(refObjectId).css('display', 'none');
                                (0, cash_dom_1.default)('[data-hide="no-data"]').css('display', 'none');
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ThankYouModule;
}());
exports.ThankYouModule = ThankYouModule;
